<template>
  <v-list dense>
    <v-list-item
        :active="checkActive(item)"
        @click="changeRouter(item)"
        v-for="(item, index) in menuItems"
        :key="index"
        :link="true"
    >
      <template v-slot:prepend>
        <v-icon size="20" :class="{ 'text-white' : checkActive(item) }">{{ item.icon }}</v-icon>
      </template>
      <v-list-item-title>
        {{ item.title }}
      </v-list-item-title>
    </v-list-item>

    <v-list-item
        class="exit__btn"
        @click="logout(true, true)"
        :link="true"
    >
      <template v-slot:prepend>
        <v-icon size="20">{{ exitItem.icon }}</v-icon>
      </template>
      <v-list-item-title>
        {{ exitItem.title }}
      </v-list-item-title>
    </v-list-item>
  </v-list>
</template>

<script>

import pa_names from "@/modules/personal_account/routers/names"
import core_names from "@/modules/core/routers/names"
import { mapActions, mapGetters } from "vuex"

export default {
  name: 'LeftMenuAppend',
  data () {
    return {
      menuItems: [
        { icon: 'home', title: 'Главная страница', router: { name: pa_names.MAIN, params: {} } },
        { icon: 'thumb_up', title: 'Партнеры', router: { name: pa_names.PARTNER.PAGE, params: {} } },
        // { icon: 'notifications', title: 'Уведомления от партнеров', router: { name: pa_names.MAIL.PAGE, params: {} } },
        // { icon: 'confirmation_number', title: 'Промокоды и акции', router: { name: pa_names.PROMO.PAGE, params: {} } },
        { icon: 'question_mark', title: 'Часто задаваемые вопросы', router: { name: pa_names.INFO.PAGE, params: {} } },
        { icon: 'mode_comment', title: 'Обращения', router: { name: pa_names.FEEDBACK.PAGE, params: {} } },
      ],
      exitItem: { icon: 'cancel', title: 'Выход', router: { name: core_names.MAIN, params: {} } }
    }
  },
  computed: {
    ...mapGetters({
      getUserStatus: 'auth/getUserStatus'
    })
  },
  methods: {
    ...mapActions({
      auth_logout: 'auth/AUTH_LOGOUT',
    }),
    checkActive: function (item) {
      const current = this.$route
      const verifiable = typeof item.router === 'object' ? item.router : { name: item.router, params: {} }
      if (verifiable.name !== current.name) { return false }
      if (Object.keys(current.params).length > Object.keys(verifiable.params).length) { return false }
      return this.checkRouteParams(Object.keys(current.params), current.params, verifiable.params)
    },
    checkRouteParams (keys, verifiable, route) {
      if (verifiable === undefined) { return false }
      if (route === undefined) { return false }
      for (const key of keys) {
        if (verifiable[key] !== route[key]) { return false }
      }
      return true
    },
    changeParam: function (item) {
      if (typeof (item) === "object") {
        return { name: item.name, params: item.params, query: item.query }
      } else {
        return { name: item }
      }
    },
    changeRouter: function (item) {
      if (this.$route.name !== item.name) {
        if (window.scrollY !== 0) {
          window.scroll({
            top: 0,
            behavior: 'smooth'
          })
        }
        this.$router.push(this.changeParam(item.router))
      }
    },
    logout: function (reload_page = false, redirect = true) {
      this.auth_logout({
        finalizer: () => {
          if (redirect) {
            this.changeRouter(this.exitItem)
          }
          if (reload_page) {
            document.location.reload()
          }
        },
        catcher: () => {
          if (reload_page) {
            document.location.reload()
          }
          this.changeRouter(this.exitItem)
        }
      })
    },
  },
  created () {
    if (this.getUserStatus) {
      if (this.getUserStatus.approve && !this.getUserStatus.agreement) {
        this.menuItems.splice(2, 0, { icon: 'confirmation_number', title: 'Промокоды и акции', router: { name: pa_names.PROMO.PAGE, params: {} } })
        this.menuItems.splice(3, 0, { icon: 'notifications', title: 'Уведомления от партнеров', router: { name: pa_names.MAIL.PAGE, params: {} } })
      }
    }
  }
}

</script>

<style scoped lang="scss">
.v-list-item {
  height: 60px;
  padding-inline-start: 46px !important;

  &:hover {
    background-color: rgba(52, 52, 124, 0.5) !important;

    .v-list-item__prepend > .v-icon, .v-list-item-title {
      color: white;
      opacity: 1;
    }
  }

  &--active {
    background-color: #34347C !important;
  }
}

//.v-navigation-drawer--rail > .v-navigation-drawer__append > .v-list > .v-list-item {
//  padding-inline-start: 14px !important;
//  transition: padding-inline-start linear .2s;
//}

.v-navigation-drawer--rail .v-navigation-drawer__content .v-list-item--density-default:not(.v-list-item--nav).v-list-item--one-line {
  padding-inline-start: 14px !important;
  transition: padding-inline-start linear .2s;
}

@media screen and (max-width: 1440px) {
  .v-navigation-drawer--is-hovering .v-navigation-drawer__content .v-list-item--density-default:not(.v-list-item--nav).v-list-item--one-line {
    padding-inline-start: 26px !important;
    transition: padding-inline-start linear .2s;
  }
}

//.exit__btn {
//  margin-top: 30px;
//}

.v-list-item__prepend > .v-icon {
  color: #34347C;
  opacity: 1;
  font-weight: bold;
  -webkit-margin-end: 39px !important;
  margin-inline-end: 39px !important;
}

.v-list-item-title {
  white-space: nowrap !important;
  text-align: left !important;
  color: white !important;
  font-size: 16px !important;
  font-weight: 600 !important;
}

@media screen and (max-width: 1560px) {
  .v-list-item {
    height: 50px;
    padding-inline-start: 26px !important;
  }

  //.exit__btn {
  //  margin-top: 25px;
  //}
}
</style>
